export const startValue = 0
export const maxDaysValue = 3
export const maxHoursValue = 23
export const maxMinutesValue = 59
export const maxSecondsValue = 59
